export default function ComparisonSection() {
  const rows = [
    { feature: 'Saves Time', spreadsheet: true, traditional: false },
    { feature: 'Trusted Sellers', spreadsheet: true, traditional: false },
    { feature: 'Organized Categories', spreadsheet: true, traditional: false },
    { feature: 'Better Prices', spreadsheet: true, traditional: 'Sometimes' },
    { feature: 'Easy Navigation', spreadsheet: true, traditional: false },
    { feature: 'Community Reviews', spreadsheet: true, traditional: false },
    { feature: 'Daily Updates', spreadsheet: true, traditional: false },
    { feature: 'Shipping Guides', spreadsheet: true, traditional: false },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-center">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-primary-600 mb-4">
              Why Spreadsheet
            </p>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
              Why Buyers Use the AllChinaBuy Spreadsheet
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg">
              Compared to traditional methods of searching for products, the AllChinaBuy spreadsheet saves time, provides trusted seller verification, and organizes everything in one convenient place. Here is how it stacks up against searching on your own.
            </p>
            <div className="mt-8">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                Explore Spreadsheet
                <i className="ri-arrow-right-up-line"></i>
              </a>
            </div>
          </div>

          <div className="bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
            <div className="grid grid-cols-3 border-b border-background-200/60">
              <div className="p-4 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Feature</div>
              <div className="p-4 text-xs font-semibold text-primary-600 uppercase tracking-wider text-center">Spreadsheet</div>
              <div className="p-4 text-xs font-semibold text-foreground-400 uppercase tracking-wider text-center">Traditional Search</div>
            </div>
            {rows.map((row, idx) => (
              <div
                key={row.feature}
                className={`grid grid-cols-3 border-b border-background-200/40 ${
                  idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'
                }`}
              >
                <div className="p-3.5 text-sm text-foreground-700 font-medium">{row.feature}</div>
                <div className="p-3.5 flex items-center justify-center">
                  {row.spreadsheet === true ? (
                    <i className="ri-check-line text-accent-500 text-lg"></i>
                  ) : (
                    <span className="text-sm text-foreground-600">{row.spreadsheet}</span>
                  )}
                </div>
                <div className="p-3.5 flex items-center justify-center">
                  {row.traditional === true ? (
                    <i className="ri-check-line text-accent-500 text-lg"></i>
                  ) : row.traditional === false ? (
                    <i className="ri-close-line text-foreground-300 text-lg"></i>
                  ) : (
                    <span className="text-sm text-foreground-500">{row.traditional}</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}